/**
 * Production-oriented defaults. Override via REACT_APP_* only when deploying to a different host
 * (e.g. REACT_APP_BACKEND_URL, REACT_APP_AGENTS_API_BASE_URL for the Express agents API).
 *
 * Agents CRUD/runs live on Express (:5000). API Gateway (defaultBackend) is for djangocaller/docdb/etc.
 * If AGENTS_API_BASE_URL fell back to defaultBackend, /agents would hit execute-api and fail or proxy wrong.
 */
const defaultEditorOrigin =
  process.env.REACT_APP_EDITOR_URL || "https://editor.workload.co:5000";
const defaultBackend =
  process.env.REACT_APP_BACKEND_URL || "https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production";

const config = {
  AI_WORKFLOW_ENDPOINT:
    process.env.REACT_APP_AI_WORKFLOW_ENDPOINT ||
    "https://e5ybl9q79g.execute-api.us-west-2.amazonaws.com/prod/ai/generate-workflow",
  KNOWLEDGE_BASE_ENDPOINT: process.env.REACT_APP_KNOWLEDGE_BASE_ENDPOINT,
  WEB_SEARCH_ENDPOINT: process.env.REACT_APP_WEB_SEARCH_ENDPOINT,
  APP_DATABASE_URL: process.env.REACT_APP_APP_DATABASE_URL,
  WS_AGENT_ENDPOINT:
    process.env.REACT_APP_WS_AGENT_ENDPOINT || "wss://8jgff1h55d.execute-api.us-west-2.amazonaws.com/prod",

  AIRTABLE_API_KEY: process.env.REACT_APP_AIRTABLE_API_KEY || "",

  BACKEND_URL: defaultBackend,
  EDITOR_URL: defaultEditorOrigin,
  AGENTS_NODE_API_BASE_URL:
    process.env.REACT_APP_AGENTS_NODE_API_BASE_URL || defaultEditorOrigin,

  MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN || "",
  HOTJAR_ID: process.env.REACT_APP_HOTJAR_ID || "",
  /** Default project key so dev/prod builds work without .env; override with REACT_APP_POSTHOG_API_KEY if needed. */
  POSTHOG_API_KEY:
    process.env.REACT_APP_POSTHOG_API_KEY ||
    "phc_ffX87yQbPucvq0qJzRozwLmclZjopVf2CAIx4CMMAoy",
  POSTHOG_HOST: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",

  NODE_ENV: process.env.NODE_ENV || "development",

  /** HTTP agents CRUD + runs (Express or API Gateway proxy). Not mock. */
  AGENTS_API_MODE: (process.env.REACT_APP_AGENTS_API_MODE || "http").toLowerCase(),
  AGENTS_API_BASE_URL:
    process.env.REACT_APP_AGENTS_API_BASE_URL || defaultEditorOrigin,

  DJANGOCALLER_API_BASE_URL: process.env.REACT_APP_DJANGOCALLER_API_BASE_URL || defaultBackend,
  DJANGOCALLER_PATH: process.env.REACT_APP_DJANGOCALLER_PATH || "/djangocaller",
  /** Lambda Function URL for enrichToolOutput / file-extract / browserAct (5 min, no API Gateway 29s cap). */
  AGENT_FILE_EXTRACT_FUNCTION_URL:
    process.env.REACT_APP_AGENT_FILE_EXTRACT_FUNCTION_URL ||
    "https://gbmsd7qh4pgigwl62w2s6bujmq0vrnnz.lambda-url.us-west-2.on.aws",
  /** Optional override for Browser preview/execute; defaults to AGENT_FILE_EXTRACT_FUNCTION_URL. */
  AGENT_BROWSER_ACT_FUNCTION_URL:
    process.env.REACT_APP_AGENT_BROWSER_ACT_FUNCTION_URL || "",
  EXECUTE_ACTION_DIRECT_URL: process.env.REACT_APP_EXECUTE_ACTION_DIRECT_URL || "",
  AGENT_BRAIN_HTTP_URL:
    process.env.REACT_APP_AGENT_BRAIN_HTTP_URL ||
    "https://j965b0opb6.execute-api.us-west-2.amazonaws.com/agent-brain",
  /** executeAction / preview runs use djangocaller unless explicitly disabled. */
  AGENTS_EXECUTE_VIA_HTTP: process.env.REACT_APP_AGENTS_EXECUTE_VIA_HTTP !== "false",

  AGENTS_WS_ENDPOINT:
    process.env.REACT_APP_AGENTS_WS_ENDPOINT || process.env.REACT_APP_WS_AGENT_ENDPOINT || "wss://8jgff1h55d.execute-api.us-west-2.amazonaws.com/prod",
  AGENT_RUN_MONGO_COLLECTION: process.env.REACT_APP_AGENT_RUN_COLLECTION || "agent_tasks",

  AI_SERVICE_URL:
    process.env.REACT_APP_AI_SERVICE_URL || "https://e5ybl9q79g.execute-api.us-west-2.amazonaws.com/prod/ai",
};

export default config;
